/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: < Amal Sabu, Ujjwal Singh >

*/
const defaultState = {
  reviewImagesList: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    //   store

    case "SWAP_REVIEW_IMAGES_PENDING": {
      return {
        ...state,
      };
    }
    case "SWAP_REVIEW_IMAGES_FULFILLED": {
      return {
        ...state,
        reviewImagesList: action.payload,
      };
    }

    case "SWAP_REVIEW_IMAGES_REJECTED": {
      return {
        ...state,
      };
    }
    case "GET_REVIEW_IMAGE_PENDING": {
      return {
        ...state,
        loading: true,
        errors: {},
      };
    }
    case "GET_REVIEW_IMAGE_FULFILLED": {
      return {
        ...state,
        reviewImagesList: action.payload.data,
        loading: false,
        errors: {},
      };
    }
    case "GET_REVIEW_IMAGE_REJECTED": {
      return {
        ...state,
        loading: false,
        errors: action.payload.errors,
      };
    }
    default:
      return state;
  }
};
